(() => {
  const sendEvent = (name) => {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, {
      event_category: 'pwa',
      transport_type: 'beacon'
    });
  };

  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  if (isStandalone) {
    try {
      if (!window.sessionStorage.getItem('vineggiamo-pwa-open')) {
        window.sessionStorage.setItem('vineggiamo-pwa-open', '1');
        sendEvent('pwa_open');
      }
    } catch (_) {
      sendEvent('pwa_open');
    }
  }

  window.addEventListener('beforeinstallprompt', () => {
    sendEvent('pwa_prompt_available');
  });

  window.addEventListener('appinstalled', () => {
    sendEvent('pwa_installed');
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-install-button]')) {
      sendEvent('pwa_install_click');
    }
  });
})();
